import { END_POINTS } from "../helpers";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
  statusCode: number;
  message?: string;
  data?: any;
};

export const serviceApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    addServices: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: END_POINTS.services,
        method: "POST",
        body,
      }),
    }),
    updateService: builder.mutation<CommonResponse, { id: string; body: any }>({
      query: ({ id, body }) => ({
        url: `${END_POINTS.serviceById}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    toggleService: builder.mutation<CommonResponse, { id: string; body: any }>({
      query: ({ id, body }) => ({
        url: `${END_POINTS.toggleService}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    getSubCategory: builder.query<
      CommonResponse,
      { parentId: string | undefined }
    >({
      query: ({ parentId }) => ({
        url: `${END_POINTS.category}?categoryIds=${parentId}`,
        method: "GET",
      }),
    }),

    getServicesList: builder.query<
      CommonResponse,
      { page?: number; limit?: number; search?: string }
    >({
      query: (params) => {
        const newParams: any = { ...params };
        if (!newParams.search) delete newParams.search;
        return {
          url: END_POINTS.servicesList,
          method: "GET",
          params: newParams,
        }
      },
    }),

    getServiceById: builder.query<CommonResponse, { id: string | undefined }>({
      query: ({ id }) => ({
        url: `${END_POINTS.serviceById}/${id}`,
        method: "GET",
      }),
    }),
    deleteService: builder.mutation<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.serviceById}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useAddServicesMutation,
  useUpdateServiceMutation,
  useLazyGetSubCategoryQuery,
  useLazyGetServicesListQuery,
  useGetServicesListQuery,
  useLazyGetServiceByIdQuery,
  useDeleteServiceMutation,
  useToggleServiceMutation
} = serviceApi;
